import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/atendimento'
const APICore = process.env.APIBaseURLCore

const GetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/all`, filters, config)
const ExportAllCardsReport = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, dataFilters, config)
const ExportAllMessages = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export_messages`, dataFilters, config)
const MedioGetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/medio`, filters, config)

const ReportAtendimentoRepository = {
  GetAll,
  ExportAllCardsReport,
  MedioGetAll,
  ExportAllMessages
}

export default ReportAtendimentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/reportAtendimento.js